import { render } from "./HeaderUserMenu.vue?vue&type=template&id=573d8e99"
import script from "./HeaderUserMenu.vue?vue&type=script&lang=js"
export * from "./HeaderUserMenu.vue?vue&type=script&lang=js"

import "./HeaderUserMenu.vue?vue&type=style&index=0&id=573d8e99&lang=scss"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__